'use strict';
import angular from 'angular';
import tiktokLanguagesHtmlUrl from './views/tiktokLanguagesList.html';
import tiktokChildDataHtmlUrl from './views/tiktokRecursiveTemplate.html';

let app = angular.module('app.tiktokLanguages.component', []);

app.component('tiktokLanguagesTargeting', {
    bindings: {
        showActions: '=',
        selectedTiktokLanguages: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: tiktokLanguagesHtmlUrl,

// The controller that handles our component logic
    controller: function(ProductService) {
        let self = this;
        self.languagesList = [];
        self.tiktokChildDataHtmlUrl = tiktokChildDataHtmlUrl;
        self.errorFetchingLanguages = false;

        self.IsChildObjectVisible = function(parent, child){
            let searchKey = $scope.search;
            let returnVal = true;
            if (undefined != searchKey && null != searchKey && searchKey.length > 0) {
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.getLanguages = function() {
            ProductService.getLanguagesContentForTiktok({ clientId: self.clientId, clusterId: self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingLanguages = false;
                    _.each(success.data, function (content) {
                        let languages = {};
                        languages.id = content.id;
                        languages.name = content.name;
                        languages.status = "";
                        languages.isChecked = false;
                        languages.parentName = content.parentName;
                        languages.childData = content.childData;
                        languages.type = content.type;
                        self.languagesList.push(languages);
                    });
                    _.each(self.selectedTiktokLanguages, function (item) {
                        item.languagesList = angular.copy(self.languagesList);
                    })
                    processLanguagesData();
                } else {
                    self.errorFetchingLanguages = true;
                }
            }, function (error) {console.log(error);});
        };

        self.handleSelectSubChild = function (item, child, selectedTiktokLanguages, indx, type) {
            if (type == "Languages") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokLanguages.languages.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokLanguages.languages, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokLanguages.languages.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokLanguages.languages.push(child);
                }
            }
        }

        self.excludeLanguages = function(data) {
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            self.selectedTiktokLanguages.push({
                languages: [],
                overLapEnabled: true,
                overLapAdded: false,
                excludeAdded: true,
                excludeEnabled: false,
                languagesList: angular.copy(self.languagesList)
            });
        }
        let processLanguagesData = function () {
            _.each(self.selectedTiktokLanguages, function (data) {
                _.each(data.languages, function (item) {
                    _.each(data.languagesList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubLanguages(e.childData,data.languages);
                        }
                    })
                })
            })
        }
        let processSubLanguages = function(childData,selectedLanguages){
            _.each(selectedLanguages,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubLanguages(e.childData,selectedLanguages);
                    }
                })
            })
        }

        self.handleSelectLanguages = function (languages, selectedTiktokLanguages) {
            if (!languages.isChecked) {
                languages.status = '';
                languages.isChecked = false;
                let selIndex = selectedTiktokLanguages.languages.indexOf(languages);
                if (selIndex >= 0) {
                    selectedTiktokLanguages.languages.splice(selIndex, 1);
                } else {
                    if (selectedTiktokLanguages.languages && selectedTiktokLanguages.languages.length > 0) {
                        if (_.find(selectedTiktokLanguages.languagesList, { id: languages.id })) {
                            let index = _.findIndex(selectedTiktokLanguages.languagesList, { id: languages.id });
                            selectedTiktokLanguages.languages.splice(index, 1);
                        }
                    }
                }
            } else {
                languages.status = 'selected';
                languages.isChecked = true;
                selectedTiktokLanguages.languages.push(languages);
            }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if (e.id == item.id) {
                    e.status = '';
                    e.isChecked = false;
                }
                if (e.childData && e.childData.length > 0) {
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        //method to handle parent selection
        self.handleSelectParent = function (parent, data) {
            if (parent.parentChecked) {
                // Parent is selected, unselect all child items
                _.each(parent.childData, function (childItem) {
                    childItem.isChecked = false;
                });
            }
        };

        //method to handle child selection
        self.handleSelectChild = function (parent, child, data) {
            if (child.isChecked) {
                // Child is selected, unselect parent
                parent.parentChecked = false;
            } else {
                // Child is unselected, check if all children are unselected
                let allUnchecked = _.every(parent.childData, function (childItem) {
                    return !childItem.isChecked;
                });
                if (allUnchecked) {
                    parent.parentChecked = true;
                }
            }
        };

        self.removeLanguages = function (item, selectedLanguages, languagesList) {
            let selIndex = selectedLanguages.indexOf(item);
            if (selIndex >= 0) {
                selectedLanguages.splice(selIndex, 1);
                self.clearSelectedData(item,languagesList);
            }
        }
        self.setExclude = function(){
            _.each(self.selectedTiktokLanguages,function(item){
                if (item.excludeAdded) {
                    self.hideExclude = true;
                }
            })
        }
        self.initComponent = function () {
            if (self.selectedTiktokLanguages && !_.isEmpty(self.selectedTiktokLanguages)) {
                self.selectedTiktokLanguages = JSON.parse(self.selectedTiktokLanguages);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getLanguages();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedTiktokLanguages = [{
                    languages: [],
                    overLapEnabled:true,
                    excludeEnabled:true
                }];
                self.enableViewMode = false;
                self.getLanguages();
            }
        };
        self.initComponent();
    }
});
